import React from 'react';

interface OutsideProps {
  onClickOutside: () => void;
}

const Outside: React.FC<React.PropsWithChildren<OutsideProps>> = ({
  children,
  onClickOutside,
}) => {
  const ref = React.useRef<HTMLSpanElement>(null);

  const handleClickOutside = React.useCallback(
    (event: MouseEvent) => {
      if (ref && !ref.current?.contains(event.target as Node)) {
        onClickOutside();
      }
    },
    [ref, onClickOutside],
  );

  React.useEffect(() => {
    const callback = handleClickOutside;

    document.addEventListener('mouseup', callback);
    return () => document.removeEventListener('mouseup', callback);
  }, [handleClickOutside]);

  return <span ref={ref}>{children}</span>;
};

export default Outside;
